import "./serviceGraphics.css";

type ScreenshotFrameProps = {
  /** Client name, used for placeholder labels and image alt text. */
  name: string;
  /** Text in the browser address bar. */
  domain: string;
  /** "web-phone" adds a phone in front of the browser window. */
  frame: "web" | "web-phone";
  /** Real screenshot paths; a labelled placeholder shows until they exist. */
  web?: string;
  phone?: string;
};

const Placeholder = ({ label }: { label: string }) => (
  <div className="gfx-shot__empty">
    <svg viewBox="0 0 50 40" aria-hidden="true">
      <circle cx="6" cy="6" r="4.5" fill="var(--is-accent)" />
      <path
        d="M6 13 V24 C6 33 13 37 19 33 C25 29 27 19 34 17 C41 15 46 21 46 27 C46 34 39 37 33 34 C28 31 25 25 20 23"
        fill="none"
        stroke="var(--is-border-dotted)"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
    <span>[{label}]</span>
  </div>
);

/**
 * Device frames for real client screenshots (Work page). Same drawing
 * system as ServiceGraphic: scales with its column, role tokens only.
 * Shows clear placeholders until screenshots are supplied.
 */
const ScreenshotFrame = ({ name, domain, frame, web, phone }: ScreenshotFrameProps) => (
  <div className={"is-gfx gfx--shot" + (frame === "web-phone" ? " gfx--shot-phone" : "")}>
    <div className="gfx-win">
      <div className="gfx-bar">
        <div className="gfx-lights">
          <i />
          <i />
          <i />
        </div>
        <div className="gfx-url">{domain}</div>
      </div>
      <div className="gfx-shot__screen">
        {web ? <img src={web} alt={`${name} website`} /> : <Placeholder label={`${name} web screenshot`} />}
      </div>
    </div>
    {frame === "web-phone" && (
      <div className="gfx-phone gfx-phone--ios gfx-shot__phone">
        <div className="gfx-phone__screen">
          <span className="gfx-island" />
          {phone ? <img src={phone} alt={`${name} app`} /> : <Placeholder label={`${name} app`} />}
        </div>
      </div>
    )}
  </div>
);

export default ScreenshotFrame;
